module.exports = __webpack_public_path__ + "static/media/kovid.0963f620.jpeg";